import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";
import React from "react";
import classNames from "classnames";
import { EventStatus, SportCodes } from "@prestosports/prestostats-core/Common";
import teamSummaryStyles from "../../football/styles/TeamSummary.styles";
import { useEventContext } from "../../../state/events/context";
import boxScoreTeamSummaryStyles from "../styles/BoxScoreTeamSummary.styles";
import { useGameContextContext } from "../../../state/game-context/context";
import { getSafe } from "../../../util/object-util";
import boxScoreStyles from "../styles/BoxScore.styles";
import TeamLogo from "../../team/components/TeamLogo";

const BoxScoreTeamSummary = ({ team, reversed, score }) => {
	const classes = teamSummaryStyles();
	const boxScoreTeamSummaryClasses = boxScoreTeamSummaryStyles();
	const boxScoreClasses = boxScoreStyles();

	const { teamName, overallRecord, conferenceRecord, id } = team || {};
	const reversedClassName = { [classes.reversed]: !reversed };

	const { state: eventState } = useEventContext();
	const currentEvent = eventState.currentEvent();
	const isFinal = EventStatus.isFinal(currentEvent);

	const { state: gameContextState } = useGameContextContext();
	const finalizeSettings = gameContextState.finalizeSettings();

	const records = [];
	if (isFinal) {
		const or = getSafe(() => finalizeSettings.records[id].overallRecord);
		if (or) {
			records.push(or);
		}
		const cr = getSafe(() => finalizeSettings.records[id].conferenceRecord);
		if (cr) {
			records.push(cr);
		}
	} else {
		if (overallRecord) {
			records.push(overallRecord);
		}
		if (conferenceRecord) {
			records.push(conferenceRecord);
		}
	}

	const eventText = (sportId) => {
		switch (sportId) {
			case SportCodes.FlagFootball:
			case SportCodes.Football:
				return records.length ? records.join(", ") : "No records";
			default:
				return null;
		}
	};

	return (
		<Grid
			container
			direction={reversed ? "row-reverse" : "row"}
			alignItems="center"
			wrap="nowrap"
			className={boxScoreTeamSummaryClasses.summaryContainer}
		>
			<Grid item className={classNames(reversedClassName)}>
				<Typography
					className={classNames(classes.scoreText, {
						[boxScoreClasses.inProgress]: !isFinal,
						[boxScoreClasses.final]: isFinal
					})}
				>
					{score}
				</Typography>
			</Grid>
			<Grid item className={classNames(reversedClassName)}>
				<Grid
					container
					direction={reversed ? "row-reverse" : "row"}
					justifyContent="flex-end"
					alignItems="center"
					wrap="nowrap"
				>
					<Grid
						item
						className={classNames(
							reversedClassName,
							boxScoreTeamSummaryClasses.teamNameContainer
						)}
					>
						<Typography className={classNames(classes.teamNameText)}>
							{teamName}
						</Typography>
						<Typography className={boxScoreTeamSummaryClasses.eventText}>
							{eventText(currentEvent.sportId)}
						</Typography>
					</Grid>
					<Grid item className={classNames(reversedClassName)}>
						<TeamLogo hideName team={team} />
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default BoxScoreTeamSummary;
